import React from "react";

const skills = [
  { name: "HTML", level: "Advanced" },
  { name: "CSS", level: "Advanced" },
  { name: "JavaScript", level: "Intermediate" },
  { name: "TypeScript", level: "Intermediate" },
  { name: "React", level: "Beginner" },
  { name: "Angular", level: "Intermediate" },
  { name: "Bootstrap", level: "Intermediate" },
];

const Frontend = () => {
  const halfLength = Math.ceil(skills.length / 2);
  const skillsLeft = skills.slice(0, halfLength);
  const skillsRight = skills.slice(halfLength);

  return (
    <div className="skills__content">
      <h3 className="skills__title">Frontend developer</h3>
      <div className="skills__box">
        <div className="skills__column">
          {skillsLeft.map((skill, index) => (
            <div className="skills__group" key={index}>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
                <div>
                  <h3 className="skills__name">{skill.name}</h3>
                  <span className="skills__level">{skill.level}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="skills__column">
          {skillsRight.map((skill, index) => (
            <div className="skills__group" key={index + halfLength}>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
                <div>
                  <h3 className="skills__name">{skill.name}</h3>
                  <span className="skills__level">{skill.level}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Frontend;
